(function () {
  const openBtn = document.getElementById('CodPopupOpen');
  const modal = document.getElementById('CodPopup');
  if (!openBtn || !modal) return;

  // Capture our own <script> tag's URL RIGHT NOW, synchronously, while
  // document.currentScript is still guaranteed to point at this file.
  // Used later to fetch the sibling "cod-cities.json" asset without
  // needing any Liquid templating inside this .js file.
  const SELF_SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';

  const closeBtn = document.getElementById('CodPopupClose'); // keep only ONE close button in HTML
  const overlay = modal.querySelector('.cod-modal__overlay');

  // Blocks we will hide/show
  const cartBlock = document.getElementById('CodCartBlock');
  const productBlock = modal.querySelector('.cod-product'); // single product summary block (will be hidden always)
  const formEl = document.getElementById('CodForm');

  // Form fields / totals
  const img = document.getElementById('CodProductImg');
  const title = document.getElementById('CodProductTitle');
  const variant = document.getElementById('CodProductVariant');

  const qtyInput = document.getElementById('CodQty');
  const qtyMinus = document.getElementById('CodQtyMinus');
  const qtyPlus = document.getElementById('CodQtyPlus');

  const hiddenVariantId = document.getElementById('CodVariantId');
  const msg = document.getElementById('CodMsg');

  const cityInput = document.getElementById('CodCity');
  const shipPill = document.getElementById('CodShipPill');
  const shippingHidden = document.getElementById('CodShippingPrice');
  const shippingBlock = document.getElementById('CodShippingBlock'); // ✅ shipping options block (radios)

  const submitBtn = document.getElementById('CodSubmitBtn');
  const submitText = document.getElementById('CodSubmitText');
  const totalEl = document.getElementById('CodTotal');

  // Top ATC (outside modal) - keep it
  const topAtcBtn = document.getElementById('CodAddToCartTop');
  const topAtcForm = document.getElementById('CodAddToCartFormTop');

  // Cart UI elements
  const cartList = document.getElementById('CodCartList');
  const cartTotalEl = document.getElementById('CodCartTotal');

  const ENDPOINT = 'https://bdist.ma/apps/cod/cod_create_order.php';

  /* =========================================================
     IMPORTANT FIX: use Shopify routes root (handles /fr/, /en/, etc.)
  ========================================================= */
  const SHOP_ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  function shopifyUrl(path) {
    const p = String(path || '').replace(/^\/+/, '');
    return (SHOP_ROOT.endsWith('/') ? SHOP_ROOT : SHOP_ROOT + '/') + p;
  }

  async function fetchJsonOrThrow(url, options = {}, errLabel = 'request failed') {
    const res = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        ...(options.headers || {})
      },
      ...options
    });

    if (!res.ok) {
      let hint = '';
      try {
        const ct = String(res.headers.get('content-type') || '');
        if (ct.includes('application/json')) {
          const j = await res.json().catch(() => null);
          if (j && (j.description || j.message)) hint = String(j.description || j.message);
        } else {
          const t = await res.text().catch(() => '');
          hint = t ? String(t).slice(0, 120) : '';
        }
      } catch (_) {}
      const extra = hint ? ` (${hint})` : '';
      throw new Error(`${errLabel}: HTTP ${res.status}${extra}`);
    }

    return res.json();
  }

  /* =========================================================
     VARIANT SYNC
  ========================================================= */
  function clampQtyMin1(v) {
    const n = parseInt(String(v || '1'), 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  // ✅ allow 0 ONLY for delete/remove actions
  function clampQtyMin0(v) {
    const n = parseInt(String(v ?? '0'), 10);
    if (!Number.isFinite(n)) return 1;
    if (n <= 0) return 0;
    return n;
  }

  function safeText(s) {
    return String(s || '').trim();
  }

  function getProductFormEl() {
    const f =
      document.querySelector('form[action^="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    return f || null;
  }

  function getCurrentVariantIdFromPage() {
    const form = getProductFormEl();
    const inputInForm = form ? form.querySelector('input[name="id"]') : null;
    const selectInForm = form ? form.querySelector('select[name="id"]') : null;

    const inputGlobal = document.querySelector('input[name="id"]');
    const selectGlobal = document.querySelector('select[name="id"]');

    const val =
      (inputInForm && inputInForm.value) ||
      (selectInForm && selectInForm.value) ||
      (inputGlobal && inputGlobal.value) ||
      (selectGlobal && selectGlobal.value) ||
      '';

    const id = parseInt(String(val || '0'), 10);
    return Number.isFinite(id) ? id : 0;
  }

  async function fetchVariantPublicJson(variantId) {
    const id = Number(variantId);
    if (!id) return { ok: false };

    try {
      const v = await fetchJsonOrThrow(`/variants/${id}.js`, {}, 'variant.js failed');
      return { ok: true, data: v };
    } catch (_) {
      return { ok: false };
    }
  }

  function extractTitlesFromVariantJs(v) {
    const fullName = safeText(v && v.name);
    const publicTitle = safeText(v && (v.public_title || v.title));

    let productTitle = '';
    let variantTitle = '';

    if (publicTitle && publicTitle !== 'Default Title') {
      variantTitle = publicTitle;
    }

    if (fullName) {
      const parts = fullName.split(' - ');
      if (parts.length >= 2) {
        productTitle = safeText(parts[0]);
        if (!variantTitle) variantTitle = safeText(parts.slice(1).join(' - '));
      } else {
        const parts2 = fullName.split(' — ');
        if (parts2.length >= 2) {
          productTitle = safeText(parts2[0]);
          if (!variantTitle) variantTitle = safeText(parts2.slice(1).join(' — '));
        } else {
          productTitle = fullName;
        }
      }
    }

    if (!productTitle) productTitle = safeText(openBtn.dataset.productTitle);
    if (!variantTitle || variantTitle === 'Default Title') variantTitle = safeText(openBtn.dataset.variantTitle);

    return { productTitle, variantTitle };
  }

  function extractImageFromVariantJs(v) {
    const fi = v && v.featured_image;
    if (!fi) return '';
    if (typeof fi === 'string') return fi;
    if (typeof fi === 'object' && fi.src) return String(fi.src);
    return '';
  }

  function extractPriceDhFromVariantJs(v) {
    const cents = (v && typeof v.price === 'number') ? v.price : null;
    if (cents == null) return null;
    return (Number(cents) || 0) / 100;
  }

  async function syncSelectedVariantIntoUI(variantId, opts = {}) {
    const id = Number(variantId);
    if (!id) return;

    openBtn.dataset.variantId = String(id);

    const vRes = await fetchVariantPublicJson(id);
    if (vRes.ok && vRes.data) {
      const v = vRes.data;

      const { productTitle, variantTitle } = extractTitlesFromVariantJs(v);
      if (productTitle) openBtn.dataset.productTitle = productTitle;
      if (variantTitle) openBtn.dataset.variantTitle = variantTitle;

      const priceDh = extractPriceDhFromVariantJs(v);
      if (priceDh != null) openBtn.dataset.price = String(priceDh);

      const vImg = extractImageFromVariantJs(v);
      if (vImg) openBtn.dataset.productImage = vImg;
    }

    const shouldUpdateModal = modal.classList.contains('is-open') || !!opts.forceModal;
    if (shouldUpdateModal) {
      const pTitle = safeText(openBtn.dataset.productTitle);
      const vTitle = safeText(openBtn.dataset.variantTitle);
      const pImg = safeText(openBtn.dataset.productImage);

      if (title) title.textContent = pTitle || '';
      if (variant) variant.textContent = vTitle || '';
      if (img && pImg) img.src = pImg;

      if (hiddenVariantId) hiddenVariantId.value = String(id);

      await applyStockUIForSelected();
      refreshTotals();
    }
  }

  function hookVariantChanges() {
    document.addEventListener('variant:change', async (e) => {
      try {
        const detail = e && e.detail ? e.detail : null;
        const id = detail && detail.variant && detail.variant.id ? Number(detail.variant.id) : 0;
        const vId = id || getCurrentVariantIdFromPage();
        if (vId) await syncSelectedVariantIntoUI(vId);
      } catch (_) {}
    });

    document.addEventListener('change', async (e) => {
      try {
        const t = e.target;
        if (!t) return;
        const isVariantSelect = t.matches && (t.matches('select[name="id"]') || t.matches('input[name="id"]'));
        if (!isVariantSelect) return;
        const vId = getCurrentVariantIdFromPage();
        if (vId) await syncSelectedVariantIntoUI(vId);
      } catch (_) {}
    });

    const form = getProductFormEl();
    const idInput = (form && form.querySelector('input[name="id"]')) || document.querySelector('input[name="id"]');
    if (idInput) {
      const obs = new MutationObserver(async () => {
        try {
          const vId = getCurrentVariantIdFromPage();
          if (vId) await syncSelectedVariantIntoUI(vId);
        } catch (_) {}
      });
      obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });

      let last = String(idInput.value || '');
      setInterval(async () => {
        const cur = String(idInput.value || '');
        if (cur && cur !== last) {
          last = cur;
          const vId = getCurrentVariantIdFromPage();
          if (vId) await syncSelectedVariantIntoUI(vId);
        }
      }, 500);
    }
  }

  /* =========================================================
     STOCK / SOLD OUT HANDLING (CLIENT SIDE)
  ========================================================= */
  const stockCache = new Map();

  async function fetchVariantStock(variantId) {
    const id = Number(variantId);
    if (!id) return { ok: false };

    if (stockCache.has(id)) return stockCache.get(id);

    try {
      const v = await fetchJsonOrThrow(`/variants/${id}.js`, {}, 'variant.js failed');
      const out = {
        ok: true,
        available: !!v.available,
        inventory_quantity: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null
      };
      stockCache.set(id, out);
      return out;
    } catch (_) {
      const out = { ok: false, available: true, inventory_quantity: null };
      stockCache.set(id, out);
      return out;
    }
  }

  function setDisabled(el, disabled) {
    if (!el) return;
    el.disabled = !!disabled;
    if (disabled) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  }

  function getSelectedVariantId() {
    const current = getCurrentVariantIdFromPage();
    if (current) return current;

    const v = parseInt(String((hiddenVariantId && hiddenVariantId.value) || openBtn.dataset.variantId || '0'), 10);
    return Number.isFinite(v) ? v : 0;
  }

  async function applyStockUIForSelected() {
    const vId = getSelectedVariantId();
    if (!vId) return;

    const st = await fetchVariantStock(vId);

    if (st.ok && st.available === false) {
      showMsg("Produit épuisé. Veuillez choisir un autre article.", "err");
      setDisabled(submitBtn, true);
      setDisabled(topAtcBtn, true);
      if (qtyInput) qtyInput.value = 1;
      return;
    }

    setDisabled(submitBtn, false);
    setDisabled(topAtcBtn, false);

    const max = (st.ok && typeof st.inventory_quantity === 'number') ? st.inventory_quantity : null;
    if (max !== null && max >= 0 && qtyInput) {
      const wanted = clampQtyMin1(qtyInput.value);
      const clamped = Math.max(1, Math.min(wanted, Math.max(max, 1)));
      if (clamped !== wanted) qtyInput.value = String(clamped);
    }
  }

  /* =========================================================
     SUCCESS PANEL
  ========================================================= */
  const panel = modal.querySelector('.cod-modal__panel');
  let successPanel = document.getElementById('CodSuccessPanel');

  function ensureSuccessPanel() {
    if (successPanel) return successPanel;

    successPanel = document.createElement('div');
    successPanel.id = 'CodSuccessPanel';
    successPanel.className = 'cod-success cod-hidden';
    successPanel.innerHTML = `
      <div class="cod-success__icon" aria-hidden="true">✓</div>
      <div class="cod-success__title">Merci !</div>
      <div class="cod-success__sub">Votre commande a été créée avec succès.</div>

      <div class="cod-success__card">
        <div class="cod-success__row"><span>Commande</span><b id="CodSuccessOrderName">—</b></div>
        <div class="cod-success__row"><span>Total</span><b id="CodSuccessTotal">—</b></div>
        <div class="cod-success__row"><span>Livraison</span><b id="CodSuccessShip">—</b></div>
      </div>
      <div class="cod-success__hint">Votre panier a été vidé. Vous pouvez continuer vos achats.</div>
    `;
    panel.appendChild(successPanel);
    return successPanel;
  }

  function showOnlySuccessUI({ orderName, totalDh, shipDh }) {
    ensureSuccessPanel();

    if (cartBlock) cartBlock.classList.add('cod-hidden');
    if (productBlock) productBlock.classList.add('cod-hidden');
    if (formEl) formEl.classList.add('cod-hidden');
    if (msg) msg.classList.add('cod-hidden');

    successPanel.classList.remove('cod-hidden');

    const nameEl = successPanel.querySelector('#CodSuccessOrderName');
    const totalEl2 = successPanel.querySelector('#CodSuccessTotal');
    const shipEl = successPanel.querySelector('#CodSuccessShip');

    if (nameEl) nameEl.textContent = orderName || '—';
    if (totalEl2) totalEl2.textContent = `${Number(totalDh || 0).toFixed(2)} dh`;
    if (shipEl) shipEl.textContent = (Number(shipDh || 0) <= 0) ? 'Gratuite' : `${Number(shipDh || 0).toFixed(0)} dh`;
  }

  function resetSuccessUI() {
    ensureSuccessPanel();
    successPanel.classList.add('cod-hidden');
    if (cartBlock) cartBlock.classList.remove('cod-hidden');
    if (productBlock) productBlock.classList.add('cod-hidden');
    if (formEl) formEl.classList.remove('cod-hidden');
    if (msg) msg.classList.remove('cod-hidden');
  }

  /* =========================================================
     Helpers
  ========================================================= */
  function normalizeCity(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')        // strip Latin accents (é, è, ï…)
      .replace(/[\u064B-\u065F\u0670]/g, '')  // strip Arabic tashkeel/diacritics
      .replace(/[إأآٱ]/g, 'ا')                 // unify alef forms -> ا
      .replace(/ى/g, 'ي')                      // alef maksura -> ya
      .replace(/ة/g, 'ه')                      // ta marbuta -> ha
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Levenshtein edit distance + similarity score (0..1), used to make city
     matching typo-tolerant: "Casablanka", "tanjaa", a missing space in the
     Arabic name, etc. should still resolve to the right city. */
  function levenshteinDistance(a, b) {
    a = String(a); b = String(b);
    const m = a.length, n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;

    const dp = new Array(n + 1);
    for (let j = 0; j <= n; j++) dp[j] = j;

    for (let i = 1; i <= m; i++) {
      let prevDiag = dp[0];
      dp[0] = i;
      for (let j = 1; j <= n; j++) {
        const tmp = dp[j];
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        dp[j] = Math.min(dp[j] + 1, dp[j - 1] + 1, prevDiag + cost);
        prevDiag = tmp;
      }
    }
    return dp[n];
  }

  function citySimilarity(a, b) {
    if (!a || !b) return 0;
    if (a === b) return 1;
    const dist = levenshteinDistance(a, b);
    const maxLen = Math.max(a.length, b.length) || 1;
    return 1 - dist / maxLen;
  }

  /* =========================================================
     CITY DATA (bilingual EN/AR, loaded from cod-cities.json asset)
     Falls back to a small built-in list instantly while the full list
     loads, so the form is never blocked waiting on the network.
  ========================================================= */
  let CITY_ENTRIES = [];       // canonical list, used to populate the dropdown
  let CITY_MATCH_ENTRIES = []; // canonical + known aliases, used for fuzzy matching / shipping
  let cityDataReady = false;

  const FALLBACK_CITIES = [
    { en: 'Casablanca', ar: 'الدار البيضاء', group: 'casa' },
    { en: 'Tanger', ar: 'طنجة', group: 'tanger' },
    { en: 'Rabat', ar: 'الرباط', group: 'other' },
    { en: 'Fès', ar: 'فاس', group: 'other' },
    { en: 'Marrakech', ar: 'مراكش', group: 'other' },
    { en: 'Salé', ar: 'سلا', group: 'other' },
    { en: 'Kénitra', ar: 'القنيطرة', group: 'other' },
    { en: 'Agadir', ar: 'أكادير', group: 'other' },
    { en: 'Tétouan', ar: 'تطوان', group: 'other' },
    { en: 'Meknès', ar: 'مكناس', group: 'other' },
    { en: 'Oujda', ar: 'وجدة', group: 'other' }
  ];

  // Old phonetic/French spellings that people still type for Casablanca /
  // Tanger. Kept as match-only aliases (never shown in the dropdown as
  // their own row) so typing them still gives the correct shipping price.
  const EXTRA_CITY_ALIASES = [
    { en: 'Casa', group: 'casa' },
    { en: 'Dar El Beida', group: 'casa' },
    { en: 'Dar El Bayda', group: 'casa' },
    { en: 'Dar Al Bayda', group: 'casa' },
    { en: 'Dar Albaida', group: 'casa' },
    { en: 'Tangier', group: 'tanger' },
    { en: 'Tanja', group: 'tanger' }
  ];

  function buildCityEntry(en, ar, group) {
    return { en, ar: ar || '', group, nEn: normalizeCity(en), nAr: normalizeCity(ar || '') };
  }

  function applyCityEntries(list) {
    CITY_ENTRIES = list.map(c => buildCityEntry(c.en, c.ar, c.group));
    CITY_MATCH_ENTRIES = CITY_ENTRIES.concat(
      EXTRA_CITY_ALIASES.map(a => buildCityEntry(a.en, '', a.group))
    );
  }

  function groupForCityCode(code) {
    const c = normalizeCity(code);
    if (c === normalizeCity('Casablanca')) return 'casa';
    if (c === normalizeCity('Tanger') || c === normalizeCity('Tangier')) return 'tanger';
    return 'other';
  }

  function cityDataAssetUrl() {
    // Build the URL for the sibling "cod-cities.json" asset from our own
    // <script src>, so we don't need any Liquid inside this .js file.
    if (SELF_SCRIPT_SRC) {
      return SELF_SCRIPT_SRC.replace(/cod-popup\.js(\?.*)?$/, 'cod-cities.json');
    }
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].src || '';
      if (src.indexOf('cod-popup.js') !== -1) {
        return src.replace(/cod-popup\.js(\?.*)?$/, 'cod-cities.json');
      }
    }
    return null;
  }

  async function loadCityData() {
    // Instant fallback so the dropdown/shipping already work even before
    // (or if) the full list has loaded.
    applyCityEntries(FALLBACK_CITIES);

    const url = cityDataAssetUrl();
    if (!url) return;

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;

      const data = await res.json();
      const list = data && Array.isArray(data.Value) ? data.Value : null;
      if (!list || !list.length) return;

      const parsed = [];
      list.forEach((c) => {
        const code = safeText(c && c.Code);
        if (!code || code === 'INTL') return;

        const en = safeText(c.EnName).replace(/\s*City$/i, '') || code;
        const ar = safeText(c.ArName);

        parsed.push({ en, ar, group: groupForCityCode(code) });
      });

      if (!parsed.length) return;

      applyCityEntries(parsed);
      cityDataReady = true;

      // If the modal is already open, refresh whatever's on screen now
      // that we have the full bilingual list.
      if (cityInput && modal.classList.contains('is-open')) {
        if (dropdownEnabled) renderCityDropdown(cityInput.value);
        applyShippingFromCity();
      }
    } catch (_) {
      // network/JSON error: keep using the fallback list already applied above
    }
  }

  /* Best (possibly fuzzy) match for whatever the user typed. Tolerates
     typos, missing accents/spaces, and Arabic vs Latin script. Returns
     the matched entry, or null if nothing is a confident enough match. */
  function findBestCityMatch(rawInput) {
    const q = normalizeCity(rawInput);
    if (!q) return null;

    let best = null;
    let bestScore = 0;

    CITY_MATCH_ENTRIES.forEach((entry) => {
      [entry.nEn, entry.nAr].forEach((candidate) => {
        if (!candidate) return;

        let score;
        if (candidate === q) {
          score = 1;
        } else if (candidate.startsWith(q) || q.startsWith(candidate)) {
          score = 0.9;
        } else if (candidate.indexOf(q) !== -1) {
          score = 0.8;
        } else {
          score = citySimilarity(q, candidate) * 0.75; // typo tolerance, capped lower than a real match
        }

        if (score > bestScore) {
          bestScore = score;
          best = entry;
        }
      });
    });

    // Require a minimum confidence so a totally unrelated string never
    // silently gets matched to a random city.
    const minScore = q.length <= 3 ? 0.55 : 0.45;
    return bestScore >= minScore ? best : null;
  }

  function normalizeCityLegacyUnused() { /* kept intentionally empty: normalizeCity is defined above */ }

  function computeShipping(cartSubtotalDh, cityRaw) {
    if ((Number(cartSubtotalDh) || 0) >= 1000) return 0;

    if (!safeText(cityRaw)) return 30;

    // Fuzzy-match whatever the user typed (typos, missing accents, Arabic
    // script, old French/Darija spellings, etc.) to find the shipping group.
    const match = findBestCityMatch(cityRaw);
    const group = match ? match.group : 'other';

    if (group === 'tanger') return 0; // ✅ Tanger free
    if (group === 'casa') return 20;

    return 30;
  }

  function getCartSubtotalDh() {
    return lastCart ? ((Number(lastCart.total_price) || 0) / 100) : 0;
  }

  function setShippingValue(val) {
    const v = Number(val) || 0;

    if (shippingHidden) shippingHidden.value = String(v);

    const radios = Array.from(modal.querySelectorAll('input[name="cod_shipping"]'));
    if (radios.length) {
      radios.forEach(r => {
        r.disabled = true;
        r.checked = (v > 0) && (String(r.value) === String(v));
      });
    }

    if (shippingBlock) {
      if (v <= 0) {
        shippingBlock.classList.add('cod-hidden');
        shippingBlock.setAttribute('aria-hidden', 'true');
      } else {
        shippingBlock.classList.remove('cod-hidden');
        shippingBlock.setAttribute('aria-hidden', 'false');
      }
    }

    if (shipPill) {
      shipPill.textContent = (v <= 0) ? 'Livraison: Gratuite' : `Livraison: ${v.toFixed(0)} dh`;
    }
  }

  function getShipping() {
    if (shippingHidden && shippingHidden.value !== '') return parseFloat(shippingHidden.value) || 0;
    const checked = modal.querySelector('input[name="cod_shipping"]:checked');
    return checked ? (parseFloat(checked.value) || 0) : 0;
  }

  function showMsg(text, type) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'cod-msg' + (type ? ' ' + type : '');
  }

  function formatServerStockErrors(data) {
    const errs = data && Array.isArray(data.errors) ? data.errors : null;
    if (!errs || !errs.length) return null;

    const lines = [];
    lines.push("Stock insuffisant pour certains articles :");

    errs.forEach((e) => {
      const t = (e && e.title) ? String(e.title) : (e && e.variant_id ? `Variant #${e.variant_id}` : 'Article');
      const avail = (e && typeof e.available === 'number') ? e.available : null;
      const req = (e && typeof e.requested === 'number') ? e.requested : null;
      const reason = (e && e.reason) ? String(e.reason) : '';

      if (reason === 'out_of_stock' || avail === 0) {
        lines.push(`• ${t} — épuisé.`);
      } else if (typeof avail === 'number' && typeof req === 'number') {
        lines.push(`• ${t} — en stock: ${avail}, demandé: ${req}.`);
      } else {
        const m = e && e.message ? String(e.message) : '';
        lines.push(`• ${t}${m ? ` — ${m}` : ''}`);
      }
    });

    return lines.join('\n');
  }

  function friendlyErrorMessage(err, data) {
    const stockMsg = formatServerStockErrors(data);
    if (stockMsg) return stockMsg;

    const raw = (data && (data.message || data.error)) ? String(data.message || data.error) : '';
    const em = (err && err.message) ? String(err.message) : '';
    const combined = (raw || em || '').trim();

    if (combined.toLowerCase().includes('téléphone') || combined.toLowerCase().includes('telephone')) return combined;
    if (combined.toLowerCase().includes('stock insuffisant') || combined.toLowerCase().includes('épuisé')) return combined;
    if (combined.toLowerCase().includes('failed to fetch')) return "Connexion interrompue. Vérifiez votre réseau puis réessayez.";
    return combined || "Erreur. Veuillez réessayer.";
  }

  function isValidMaPhone(phone) {
    const s = String(phone || '').trim();
    if (!s) return false;
    const digits = s.replace(/[^\d]/g, '');
    if (/^0[5-7]\d{8}$/.test(digits)) return true;
    if (/^212[5-7]\d{8}$/.test(digits)) return true;
    return false;
  }

  function getPhoneInput() {
    const el = document.getElementById('CodPhone');
    return el ? String(el.value || '').trim() : '';
  }

  /* =========================================================
     CITY DROPDOWN (bilingual display + fuzzy/typo-tolerant ranking)
  ========================================================= */
  const cityDropdown = document.getElementById('CodCityDropdown');
  let dropdownEnabled = false;

  function rankCityEntries(filterText, limit) {
    const q = normalizeCity(filterText);

    if (!q) return CITY_ENTRIES.slice(0, limit);

    const scored = CITY_ENTRIES.map((entry) => {
      let score = 0;
      [entry.nEn, entry.nAr].forEach((candidate) => {
        if (!candidate) return;
        let s;
        if (candidate === q) s = 1;
        else if (candidate.startsWith(q)) s = 0.95;
        else if (candidate.indexOf(q) !== -1) s = 0.85;
        else s = citySimilarity(q, candidate) * 0.7; // typo tolerance
        if (s > score) score = s;
      });
      return { entry, score };
    });

    const minScore = q.length <= 2 ? 0.55 : 0.4;

    return scored
      .filter(s => s.score >= minScore)
      .sort((a, b) => b.score - a.score)
      .slice(0, limit)
      .map(s => s.entry);
  }

  function renderCityDropdown(filterText) {
    if (!cityDropdown || !cityInput) return;
    if (!dropdownEnabled) return;

    const items = rankCityEntries(filterText, 40);

    if (!items.length) {
      cityDropdown.classList.remove('is-open');
      cityDropdown.innerHTML = '';
      cityDropdown.setAttribute('aria-hidden', 'true');
      return;
    }

    const currentSub = getCartSubtotalDh();

    cityDropdown.innerHTML = items.map((entry) => {
      const ship = computeShipping(currentSub, entry.en);
      const tag = (ship <= 0) ? 'Gratuite' : (ship === 20 ? '20 dh' : '30 dh');
      const label = entry.ar ? `${entry.en} — ${entry.ar}` : entry.en;
      const cityAttr = entry.en.replace(/"/g, '&quot;');
      return `
        <div class="cod-city__item" data-city="${cityAttr}">
          <span>${label}</span>
          <span class="cod-city__tag">${tag}</span>
        </div>
      `;
    }).join('');

    cityDropdown.classList.add('is-open');
    cityDropdown.setAttribute('aria-hidden', 'false');
  }

  function closeCityDropdown() {
    if (!cityDropdown) return;
    cityDropdown.classList.remove('is-open');
    cityDropdown.setAttribute('aria-hidden', 'true');
  }

  function isClickInside(el, target) {
    return el && (el === target || el.contains(target));
  }

  /* =========================================================
     CART + totals (UPDATED: delete uses qty=0 properly)
  ========================================================= */
  let lastCart = null;

  async function fetchCart() {
    const res = await fetch(shopifyUrl('cart.js'), { credentials: 'same-origin', cache: 'no-store' });

    if (!res.ok) {
      const status = res.status;
      let raw = '';
      try { raw = await res.text(); } catch (_) {}
      const err = new Error(`cart.js failed: HTTP ${status}`);
      err.http = status;
      err.raw = raw;
      throw err;
    }

    return res.json();
  }

  async function changeLine(line, quantity) {
    const url = shopifyUrl('cart/change.js');
    const payload = { line: Number(line), quantity: Number(quantity) };
    const body = JSON.stringify(payload);

    for (let attempt = 0; attempt < 2; attempt++) {
      const res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body
      });

      if (res.status === 422) {
        let data = null;
        try { data = await res.json(); } catch (_) {}

        const m =
          (data && (data.description || data.message)) ?
            String(data.description || data.message) :
            "Quantité indisponible pour ce produit.";

        showMsg(m, 'err');

        const cart = await fetchCart();
        renderCart(cart);
        await applyShippingFromCity();
        return cart;
      }

      if (res.status === 429 && attempt === 0) {
        await new Promise(r => setTimeout(r, 450));
        continue;
      }

      if (!res.ok) {
        let hint = '';
        try {
          const data = await res.json().catch(() => null);
          if (data && (data.description || data.message)) hint = String(data.description || data.message);
        } catch (_) {}
        const err = new Error(`cart/change.js failed: HTTP ${res.status}${hint ? ` (${hint})` : ''}`);
        err.http = res.status;
        throw err;
      }

      return res.json();
    }
  }

  // per-line queue
  const lineQueue = new Map(); // line -> { timer, busy, desiredQty }

  function setLineControlsDisabled(line, disabled) {
    if (!cartList) return;
    cartList.querySelectorAll(`[data-cart-inc="${line}"],[data-cart-dec="${line}"],[data-cart-rm="${line}"],[data-cart-qty="${line}"]`)
      .forEach(el => { el.disabled = !!disabled; });
  }

  // ✅ allowZero flag fixes delete: quantity 0 must stay 0
  function scheduleLineUpdate(line, desiredQty, variantIdForCheck, allowZero = false) {
    line = Number(line);

    const qty = allowZero ? clampQtyMin0(desiredQty) : clampQtyMin1(desiredQty);

    const st = lineQueue.get(line) || { timer: null, busy: false, desiredQty: qty };
    st.desiredQty = qty;

    if (st.timer) clearTimeout(st.timer);

    st.timer = setTimeout(async () => {
      if (st.busy) return;
      st.busy = true;
      setLineControlsDisabled(line, true);

      try {
        // if removing (qty=0), skip stock checks
        if (st.desiredQty > 0 && variantIdForCheck) {
          const check = await validateQtyAgainstStock(variantIdForCheck, st.desiredQty);
          if (!check.ok) {
            showMsg(check.message, 'err');
            st.desiredQty = Math.max(1, check.qty || 1);
          } else {
            st.desiredQty = check.qty;
          }
        }

        const updated = await changeLine(line, st.desiredQty);
        renderCart(updated);
        await applyShippingFromCity();
      } catch (err) {
        if (err && err.http === 429) {
          showMsg("Trop de tentatives rapides. Attendez 1 seconde puis réessayez.", "err");
        } else {
          showMsg(err?.message || 'Erreur.', 'err');
        }
      } finally {
        st.busy = false;
        setLineControlsDisabled(line, false);
      }
    }, 220);

    lineQueue.set(line, st);
  }

  async function clearCart() {
    await fetchJsonOrThrow(shopifyUrl('cart/clear.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    }, 'cart/clear.js failed');
    return fetchCart();
  }

  function formatMoneyFromCents(cents) {
    const n = (Number(cents) || 0) / 100;
    return `${n.toFixed(2)} dh`;
  }

  function getCartQtyForVariant(variantId) {
    if (!lastCart || !Array.isArray(lastCart.items)) return 0;
    const it = lastCart.items.find(x => Number(x.variant_id) === Number(variantId));
    return it ? Number(it.quantity || 0) : 0;
  }

  function computeOrderTotalDh() {
    const cartSubDh = lastCart ? ((Number(lastCart.total_price) || 0) / 100) : 0;
    const shipDh = getShipping();
    const orderTotal = cartSubDh + shipDh;
    return { cartSubDh, shipDh, orderTotal };
  }

  function refreshTotals() {
    const t = computeOrderTotalDh();
    if (cartTotalEl) cartTotalEl.textContent = `${t.cartSubDh.toFixed(2)} dh`;
    if (totalEl) totalEl.textContent = `— ${t.orderTotal.toFixed(2)} dh`;
  }

  async function applyShippingFromCity() {
    if (!cityInput) return;

    let cart = lastCart;
    if (!cart) {
      cart = await fetchCart().catch(() => null);
      if (cart) renderCart(cart);
    }

    const subDh = cart ? ((Number(cart.total_price) || 0) / 100) : 0;
    setShippingValue(computeShipping(subDh, cityInput.value));

    if (dropdownEnabled) renderCityDropdown(cityInput.value);

    refreshTotals();
  }

  async function validateQtyAgainstStock(variantId, desiredQty) {
    const st = await fetchVariantStock(variantId);
    if (!st.ok) return { ok: true, qty: desiredQty };

    if (st.available === false) return { ok: false, message: "Produit épuisé.", qty: 0 };

    if (typeof st.inventory_quantity === 'number') {
      const max = st.inventory_quantity;
      if (max <= 0) return { ok: false, message: "Produit épuisé.", qty: 0 };
      if (desiredQty > max) return { ok: false, message: `Quantité indisponible. Stock: ${max}.`, qty: max };
    }
    return { ok: true, qty: desiredQty };
  }

  function renderCart(cart) {
    lastCart = cart;

    const hasUI = cartBlock && cartList;
    const hasItems = cart && Array.isArray(cart.items) && cart.items.length > 0;

    if (hasUI) {
      cartBlock.style.display = hasItems ? '' : 'none';

      if (!hasItems) {
        cartList.innerHTML = '';
      } else {
        cartList.innerHTML = cart.items.map((it, idx) => {
          const line = idx + 1;
          const imgHtml = it.image
            ? `<img src="${it.image}" alt="" style="width:52px;height:52px;object-fit:cover;border-radius:12px;border:1px solid rgba(0,0,0,.12);background:#fff">`
            : '';
          const titleTxt = (it.product_title || it.title || '').replace(/</g, '&lt;');
          const variantTxt = (it.variant_title || '').replace(/</g, '&lt;');

          return `
            <div class="cod-product" style="margin:10px 0;padding:10px">
              ${imgHtml}
              <div style="flex:1;min-width:0">
                <div class="cod-product__title" style="font-size:14px">${titleTxt}</div>
                ${variantTxt ? `<div class="cod-product__variant" style="font-size:12px">${variantTxt}</div>` : ''}
                <div style="display:flex;align-items:center;gap:10px;margin-top:8px;flex-wrap:wrap">
                  <b>${formatMoneyFromCents(it.price)}</b>
                  <div style="display:flex;align-items:center;gap:8px;margin-left:auto">
                    <button type="button" class="cod-qty__btn" data-cart-dec="${line}">−</button>
                    <input
                      class="cod-input cod-qty-input"
                      type="number"
                      min="1"
                      step="1"
                      value="${it.quantity}"
                      data-cart-qty="${line}"
                      inputmode="numeric"
                      aria-label="Quantité"
                      style="max-width:90px;text-align:center"
                    >
                    <button type="button" class="cod-qty__btn" data-cart-inc="${line}">+</button>
                    <button type="button" class="cod-qty__btn" data-cart-rm="${line}" style="width:auto;padding:0 12px;font-size:14px">Supprimer</button>
                  </div>
                </div>
              </div>
            </div>
          `;
        }).join('');

        cartList.querySelectorAll('[data-cart-inc]').forEach(btn => {
          btn.addEventListener('click', () => {
            const line = Number(btn.getAttribute('data-cart-inc'));
            const item = lastCart.items[line - 1];
            if (!item) return;
            scheduleLineUpdate(line, (item.quantity || 1) + 1, item.variant_id, false);
          });
        });

        cartList.querySelectorAll('[data-cart-dec]').forEach(btn => {
          btn.addEventListener('click', () => {
            const line = Number(btn.getAttribute('data-cart-dec'));
            const item = lastCart.items[line - 1];
            if (!item) return;
            scheduleLineUpdate(line, Math.max((item.quantity || 1) - 1, 1), item.variant_id, false);
          });
        });

        // ✅ FIX: delete must send 0 (allowZero=true), otherwise it becomes 1
        cartList.querySelectorAll('[data-cart-rm]').forEach(btn => {
          btn.addEventListener('click', () => {
            const line = Number(btn.getAttribute('data-cart-rm'));
            const item = lastCart.items[line - 1];
            scheduleLineUpdate(line, 0, item ? item.variant_id : null, true);
          });
        });

        cartList.querySelectorAll('[data-cart-qty]').forEach(inp => {
          inp.addEventListener('input', () => {
            const line = Number(inp.getAttribute('data-cart-qty'));
            const item = lastCart.items[line - 1];
            const vId = item ? item.variant_id : null;
            scheduleLineUpdate(line, inp.value, vId, false);
          });
          inp.addEventListener('blur', () => {
            const v = clampQtyMin1(inp.value);
            inp.value = String(v);
          });
        });
      }
    }

    refreshTotals();
  }

  /* =========================================================
     Add/update selected into cart BEFORE opening modal
  ========================================================= */
  async function addToCartDelta(variantId, desiredTotalQty) {
    const cart = lastCart || await fetchCart();
    renderCart(cart);

    const currentQty = getCartQtyForVariant(variantId);
    const desired = clampQtyMin1(desiredTotalQty);

    const checkTotal = await validateQtyAgainstStock(variantId, desired);
    if (!checkTotal.ok) throw new Error(checkTotal.message);

    const delta = Math.max(desired - currentQty, 0);
    if (delta <= 0) return true;

    const cart2 = await fetchJsonOrThrow(shopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(delta) })
    }, 'cart/add.js failed');

    renderCart(cart2);
    return true;
  }

  /* =========================================================
     MODAL open/close
  ========================================================= */
  async function open() {
    resetSuccessUI();

    if (productBlock) productBlock.classList.add('cod-hidden');

    const currentVariantId = getCurrentVariantIdFromPage();
    if (currentVariantId) {
      await syncSelectedVariantIntoUI(currentVariantId, { forceModal: false });
    }

    const vId = getSelectedVariantId();
    const desiredQty = clampQtyMin1((qtyInput && qtyInput.value) || 1);
      
    if (vId) {
      // ✅ always get fresh cart before deciding
      const cartNow = await fetchCart();
      renderCart(cartNow);
    
      const alreadyInCart = cartNow.items && cartNow.items.some(it => Number(it.variant_id) === Number(vId));
    
      // ✅ if already exists in panier, do NOT add again
      if (!alreadyInCart) {
        await addToCartDelta(vId, desiredQty);
      }
    }

    const productTitle = openBtn.dataset.productTitle || '';
    const productImage = openBtn.dataset.productImage || '';
    const variantTitle = openBtn.dataset.variantTitle || '';
    const variantId = openBtn.dataset.variantId || (currentVariantId ? String(currentVariantId) : '');

    if (title) title.textContent = productTitle;
    if (variant) variant.textContent = variantTitle;
    if (img && productImage) img.src = productImage;
    if (hiddenVariantId) hiddenVariantId.value = variantId;

    showMsg('', '');

    dropdownEnabled = false;
    closeCityDropdown();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (e) {
      lastCart = null;
      refreshTotals();
      throw e;
    }

    await applyShippingFromCity();
    await applyStockUIForSelected();

    const nameInput = document.getElementById('CodName');
    if (nameInput) setTimeout(() => nameInput.focus(), 50);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    closeCityDropdown();
    dropdownEnabled = false;
  }

  openBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    try {
      await open();
    } catch (err) {
      showMsg(err?.message || 'Erreur.', 'err');
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* =========================================================
     QTY controls (selected product) + stock clamp
  ========================================================= */
  async function syncQty(newQty) {
    if (!qtyInput) return;

    const vId = getSelectedVariantId();
    const desired = clampQtyMin1(newQty);

    const check = await validateQtyAgainstStock(vId, desired);
    if (!check.ok) {
      showMsg(check.message, 'err');
      qtyInput.value = String(Math.max(check.qty || 1, 1));
      refreshTotals();
      return;
    }

    qtyInput.value = String(check.qty);
    refreshTotals();
  }

  if (qtyMinus) qtyMinus.addEventListener('click', () => syncQty(clampQtyMin1((qtyInput && qtyInput.value)) - 1));
  if (qtyPlus) qtyPlus.addEventListener('click', () => syncQty(clampQtyMin1((qtyInput && qtyInput.value)) + 1));
  if (qtyInput) qtyInput.addEventListener('input', () => syncQty(qtyInput.value));

  /* =========================================================
     TOP ADD TO CART (outside modal)
  ========================================================= */
  function findProductPageQty() {
    const candidates = [
      'form[action^="/cart/add"] input[name="quantity"]',
      'input[name="quantity"]',
      'input.quantity__input',
      'quantity-input input',
      '#Quantity-1',
      '#quantity',
      'input[id*="Quantity"]'
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el && el.value != null && String(el.value).trim() !== '') return clampQtyMin1(el.value);
    }
    return 1;
  }

  async function addToCartStay(variantId, qty) {
    const check = await validateQtyAgainstStock(variantId, qty);
    if (!check.ok) throw new Error(check.message);

    const cart = await fetchJsonOrThrow(shopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(check.qty) })
    }, 'cart/add.js failed');

    renderCart(cart);
    await applyShippingFromCity();
    return true;
  }

  if (topAtcForm) {
    topAtcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        const variantId = getSelectedVariantId();
        const qty = findProductPageQty();
        if (!variantId) return;

        const check = await validateQtyAgainstStock(variantId, qty);
        if (!check.ok) return showMsg(check.message, 'err');

        if (topAtcBtn) topAtcBtn.disabled = true;
        await addToCartStay(variantId, check.qty);

        const old = topAtcBtn ? topAtcBtn.textContent : '';
        if (topAtcBtn) topAtcBtn.textContent = 'Ajouté ✅';
        setTimeout(() => { if (topAtcBtn) topAtcBtn.textContent = old; }, 1200);
      } catch (err) {
        showMsg(err?.message || 'Erreur.', 'err');
      } finally {
        if (topAtcBtn) topAtcBtn.disabled = false;
      }
    }, true);
  }

  /* =========================================================
     Submit (COD): create order ONLY from cart items
  ========================================================= */
  function cartItemsToJson(cart) {
    if (!cart || !Array.isArray(cart.items)) return '[]';
    return JSON.stringify(cart.items.map(it => ({ variant_id: it.variant_id, quantity: it.quantity })));
  }

  async function applyStockFixFromServerErrors(errors) {
    if (!lastCart || !Array.isArray(lastCart.items) || !Array.isArray(errors)) return;

    const lineByVariant = new Map();
    lastCart.items.forEach((it, idx) => {
      lineByVariant.set(Number(it.variant_id), idx + 1);
    });

    for (const e of errors) {
      const vid = Number(e.variant_id);
      const line = lineByVariant.get(vid);
      if (!line) continue;

      if (e.available === null) continue;

      const avail = Number(e.available);
      if (!Number.isFinite(avail)) continue;

      try {
        if (avail <= 0) {
          await changeLine(line, 0);
        } else {
          await changeLine(line, avail);
        }
      } catch (_) {}
    }

    try {
      const cart = await fetchCart();
      renderCart(cart);
      await applyShippingFromCity();
    } catch (_) {}
  }

  if (!formEl) return;

  formEl.addEventListener('submit', async function (e) {
    e.preventDefault();
    showMsg('', '');

    const phoneRaw = getPhoneInput();
    if (!isValidMaPhone(phoneRaw)) {
      showMsg("Numéro de téléphone invalide. Exemple: +2126XXXXXXXX ou 06XXXXXXXX.", 'err');
      const phoneEl = document.getElementById('CodPhone');
      if (phoneEl) phoneEl.focus();
      return;
    }

    if (cityInput && !cityInput.value.trim()) {
      showMsg('Veuillez choisir une ville.', 'err');
      cityInput.focus();
      return;
    }

    submitBtn.disabled = true;
    if (submitText) submitText.textContent = 'Traitement...';

    try {
      const cart = await fetchCart();
      renderCart(cart);

      if (!cart.items || !cart.items.length) {
        throw new Error("Votre panier est vide.");
      }

      await applyShippingFromCity();

      for (const it of cart.items) {
        const check = await validateQtyAgainstStock(it.variant_id, it.quantity);
        if (!check.ok) throw new Error(check.message);
      }

      const itemsJson = cartItemsToJson(cart);
      const totals = computeOrderTotalDh();

      const form = new FormData(e.target);
      form.set('items_json', itemsJson);
      form.set('shipping_price', String(getShipping()));

      const res = await fetch(ENDPOINT, { method: 'POST', body: form });
      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.success) {
        if (data && data.code === 'STOCK') {
          showMsg(friendlyErrorMessage(new Error(''), data), 'err');
          if (Array.isArray(data.errors) && data.errors.length) {
            await applyStockFixFromServerErrors(data.errors);

            const vId = getSelectedVariantId();
            const match = data.errors.find(x => Number(x.variant_id) === Number(vId));
            if (match && typeof match.available === 'number' && qtyInput) {
              qtyInput.value = String(Math.max(1, Number(match.available) || 1));
              refreshTotals();
            }
          }
          throw new Error('');
        }

        throw new Error(friendlyErrorMessage(new Error(''), data));
      }

      try {
        const emptyCart = await clearCart();
        renderCart(emptyCart);
        await applyShippingFromCity();
      } catch (_) {}

      refreshTotals();

      showOnlySuccessUI({
        orderName: data.order_name || data.order_number || data.order_id || '—',
        totalDh: totals.orderTotal,
        shipDh: totals.shipDh
      });
    } catch (err) {
      resetSuccessUI();
      const m = (err && err.message) ? String(err.message) : '';
      if (m) showMsg(m, 'err');
      else showMsg("Erreur. Veuillez réessayer.", 'err');
    } finally {
      submitBtn.disabled = false;
      if (submitText) submitText.textContent = 'Achetez';
    }
  });

  /* =========================================================
     City dropdown events
  ========================================================= */
  if (cityDropdown && cityInput) {
    cityInput.addEventListener('focus', () => {
      dropdownEnabled = true;
      renderCityDropdown(cityInput.value);
    });

    cityInput.addEventListener('input', () => {
      dropdownEnabled = true;
      renderCityDropdown(cityInput.value);
      applyShippingFromCity();
    });

    cityInput.addEventListener('blur', () => setTimeout(closeCityDropdown, 120));

    cityDropdown.addEventListener('mousedown', (e) => {
      const item = e.target.closest('.cod-city__item');
      if (!item) return;
      cityInput.value = item.getAttribute('data-city') || '';
      closeCityDropdown();
      applyShippingFromCity();
    });

    document.addEventListener('click', (e) => {
      if (!isClickInside(cityDropdown, e.target) && !isClickInside(cityInput, e.target)) {
        closeCityDropdown();
      }
    });
  } else if (cityInput) {
    cityInput.addEventListener('input', applyShippingFromCity);
    cityInput.addEventListener('change', applyShippingFromCity);
    cityInput.addEventListener('blur', applyShippingFromCity);
  }

  /* =========================================================
     Init
  ========================================================= */
  (async () => {
    try {
      loadCityData(); // fire-and-forget: fallback list is applied synchronously,
                       // full bilingual list swaps in once cod-cities.json arrives

      const vId = getCurrentVariantIdFromPage();
      if (vId) await syncSelectedVariantIntoUI(vId);

      hookVariantChanges();
      await applyStockUIForSelected();

      if (productBlock) productBlock.classList.add('cod-hidden');

      const cart = await fetchCart();
      renderCart(cart);
      await applyShippingFromCity();
    } catch (e) {
      showMsg(e?.message || 'Erreur.', 'err');
    }
  })();
})();